import { privateAxios } from '@/common/api/axios';
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant';
import { Mapper } from '@/common/services/mapper';
import { MetaResponse } from '@/common/types/metaResponse';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

type UseBillingBillEventsProps<T> = {
  filters?: {
    id?: string;
    search?: string;
    page?: number;
    authorId?: string;
    companyBranchId?: string;
    eventableType?: string;
    equipmentId?: number;
  };
  mapper?: (data: any) => T;
};

export const useBillingBillEvents = <T,>({
  filters: { id, search = '', authorId, companyBranchId, eventableType, equipmentId, page = 1 } = {},
  mapper = Mapper.default<T>(),
}: UseBillingBillEventsProps<T>) => {
  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['billingBillEvents', id, search, authorId, companyBranchId, eventableType, equipmentId, page],
    queryFn: () => {
      return privateAxios.get(`/billing/bills/${id}/events`, {
        params: {
          search,
          'q[author_id_eq]': authorId,
          'q[company_branch_id_eq]': companyBranchId,
          'q[eventable_type_eq]': eventableType,
          'q[equipment_id_eq]': equipmentId,
          page,
        },
      });
    },
    select: (data: { data: { data: any[]; meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
